import { BaseLayerOptions } from './base-layer-options';
import { SelectedCircleOptions } from './selected-circle-options';

export class IconLayerOptions extends BaseLayerOptions {
    icon: any;
    selectedIcon?: string;
    useIconFromProperties = false;
    interactive = true;

    // will automatically filter out features that are points only
    // will not work if we want to add icons along a line
    useDefaultPointFilter = true;

    iconColor?: any;
    useColorFromProperties = false;
    iconSize?: any;
    iconOffset?: any;
    iconOpacity?: any;
    iconHaloColor?: any;
    iconHaloWidth?: any;
    selectedIconColor?: any;

    text: any;
    textSize: any;
    textAnchor: string;
    textOffset: any;
    textColor: any;
    textFont: any;
    textOpacity: any;
    textHaloColor: any;
    textHaloWidth: any;
    textMaxWidth: any;
    textKeepUpRight: boolean;
    iconRotationAlignment?: any;
    textAllowOverlap = true;

    symbolSortKey: string;
    symbolSpacing: any;
    symbolPlacement: string;
    iconRotate = true;

    selectedCircleOptions?: SelectedCircleOptions;
}
